<template>
	<div>
			<div class="menu" v-for='c of col' :key="c">
					<div class="menu-item" v-for='(item, index) in navList' :key="i" v-if="isShow(item,index,c)"  @click="activityList({link:'products', query:{category:item.cid},  params:{ name:item.name,isFromHome:true}})">
							<img class="menu-item-icon" :src="item.photo" />
					</div>
			</div>
		</div>

</template>

<script>
import { mapState, mapGetters,mapActions } from 'vuex';
import { ENUM } from '../../../const/enum.js';

export default {
  name: "HomeMenu",
  computed: {
  	...mapState({
			isOnline: state => state.auth.isOnline,
			navList: state => state.home.navList,
			orderStatus: state => state.order.orderStatus,
		})
	},
	data(){
		return {
      col:[]
    }
	},
	created(){
		if (this.navList && this.navList.length) {

    }else{
      this.fetchNavList({}).then(
        response => {
					var max = Math.ceil(this.navList.length/4)
					for(var m=0;m<max;m++){
						this.col.push(m)
					}
				},
        error => {}
      )
    }
	},
  methods: {
		...mapActions({
      fetchNavList: 'fetchNavList',
		}),
		isShow:function(item,index,c) {
			return  Math.floor(index/4) == c  &&  item.ifshow =='1' 
  	},
  	activityList: function(item) {
			this.$router.push({ name: item.link, query:item.query });
  	},
  }
};
</script>

<style lang="scss" scoped>
.menu {
  width: 100%;
  display: flex;
  justify-content: row;
  padding: 16px 6px;
  background: #FFFFFF;
  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .menu-item-icon {
      width: 54%;
      height: auto;
      overflow: hidden;
    }
    .menu-item-title {
      color: #333333;
      font-size: 12px;
      margin-top: 3px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/home/child/HomeMenu.vue